
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/nis2",
      function () {
        return require("private-next-pages/compliance/nis2.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/nis2"])
      });
    }
  